import React from 'react';
import { StyleSheet, View } from 'react-native';
import CommonStyle from '../../../styles/CommonStyle';

export default function SpacerMinV() {
    return <View style={CommonStyle("vertSpacerMini")} />
}